export class AnnouncementFeedbackModel {
 
  companyName: string;
  createdBy: string;
  feedbackDate: Date;
  feedbackNotes: string;
  announcementTitle: string;
  messageDetail: string;
  releaseDate: Date;
  expirationDate: Date;
  requestNumber: string;
}




// WEBPACK FOOTER //
// ./src/app/core/models/announcement-feedback.ts